<template>
  <div class="mt-component-form">
    <vs-row class="my-4 center-flex justify-start xl:justify-center gap-y-3">
      <h5><i class="dot"></i>{{ $t(title) }}</h5>
      <div class="ml-auto flex gap-4">
        <vs-button
          v-if="!isPrint"
          class=""
          color="secondary"
          type="border"
          @click="handleAddRow"
        >{{ $t('항목추가') }}</vs-button>
        <vs-button
          v-if="!isPrint"
          color="secondary"
          @click="handleRemoveRow"
          :disabled="!list.find(x => x.input_check)"
        >{{ $t('선택삭제') }}</vs-button>
      </div>
    </vs-row>
    <div class="w-full overflow-x-auto">
      <table class="form-table w-full">
        <thead>
        <tr class="form-header-row">
          <th style="width: 50px; min-width: 50px; padding-left: 0; padding-right: 0;">
            <vs-checkbox
              @change="handleCheckAll"
              style="padding-left: 10px;"
              :value="allChecked" />
          </th>
          <th style="width: 214px; min-width: 214px;">{{ $t('공정사진') }}</th>
          <th>{{ $t('평가구분') }}</th>
          <th>{{ $t('유해·위험요인') }}</th>
          <th>{{ $t('위험 기계·기구·설비') }}</th>
          <th>{{ $t('재해형태') }}</th>
          <th>{{ $t('등록(인증)번호') }}</th>
          <th>{{ $t('등록일') }}</th>
          <th>{{ $t('만료일') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row, rowIndex) in list" :key="rowIndex">
          <td style="padding-left: 0; padding-right: 0;">
            <vs-checkbox
              style="padding-left: 10px;"
              v-model="row.input_check"
              :readonly="readonly" />
          </td>
          <!-- 공정사진 -->
          <td>
            <div :class="!isPrint? 'upload-content__file':''">
              <div :class="!isPrint? 'upload-content__content':''">
                <div v-if="isPrint || readonly">
                  <img v-if="row.image && row.image.thumb" class="w-full printImg" :src="row.image.thumb" alt="" />
                </div>
                <FileUploaderTransparent
                  v-else
                  style="background-size: contain; background-repeat: no-repeat"
                  v-model="row.image"
                  :readonly="readonly"
                  @input="setFile(rowIndex, row.image)"
                  @progress="(state) => { fileProgress(rowIndex, state) }"
                />
                <simple-spinner
                  v-if="loadingSpinners[rowIndex]"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #cdcdcdaa"/>
              </div>
            </div>
            <div :title="row.사진내용">
              <p v-if="isPrint || readonly" class="w-full flex-1 print-input">
                {{ row.사진내용 }}
              </p>
              <ml-input
                v-else
                class="w-full text-left"
                v-model="row.사진내용"
                :placeholder="$t('입력')"
              />
            </div>
          </td>

          <!-- 평가구분 -->
          <td :title="row.input_2">
            <p v-if="isPrint" class="w-full flex-1">
              {{ $t(row.input_2) }}
            </p>
            <check-type-a-selector
              v-else
              v-model="row.input_2"
              :readonly="readonly"
              class="w-full"
              @change="handleTypeInput(rowIndex)"
            />
          </td>

          <!-- 유해·위험요인 -->
          <td :title="row.input_4">
            <p v-if="isPrint">
              {{ $t(row.input_4) }}
            </p>
            <template v-else>
              <template v-if="row.input_2 === '기타'">
                <ml-input
                  class="w-full text-left"
                  v-model="row.input_4"
                  :placeholder="$t('입력')"
                />
              </template>
              <vs-select
                v-else
                class="w-full"
                autocomplete
                v-model="row.input_4"
                :disabled="readonly || !row.input_2"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="$t(item.text)"
                  v-for="(item, index) in handleAppraisalType(row.input_2)"
                />
              </vs-select>
            </template>
          </td>

          <!-- 위험 기계·기구·설비 -->
          <td :title="row.input_5">
            <div v-if="isPrint">
              <p >
                {{ $t(row.input_5) }}
              </p>
              <p v-show="row.input_5.includes('직접입력')">
                {{ row.input_5_0 }}
              </p>
            </div>
            <div v-else>
              <vs-select
                class="w-full"
                autocomplete
                v-model="row.input_5"
                :disabled="readonly"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="$t(item.text)"
                  v-for="(item, index) in 위험기계기구설비옵션()"
                />
              </vs-select>
              <div v-show="row.input_5.includes('직접입력')" class="mt-2">
                <ml-input v-model="row.input_5_0" />
              </div>
            </div>
          </td>

          <!-- 재해형태 -->
          <td :title="row.input_3">
            <p v-if="isPrint" class="w-full flex-1">
              {{ $t(row.input_3) }}
            </p>
            <disaster-class-selector
              v-else
              class="w-full"
              v-model="row.input_3"
            />
          </td>
          <td :title="row.등록번호">
            <p v-if="isPrint || readonly" class="w-full flex-1">
              {{ row.등록번호 }}
            </p>
            <ml-input
              v-else
              class="w-full text-left"
              v-model="row.등록번호"
              :placeholder="$t('입력')"
            />
          </td>
          <td :title="row.등록일">
            <p v-if="isPrint || readonly" class="w-full flex-1">
              {{ row.등록일 }}
            </p>
            <date-selector v-else v-model="row.등록일" :readonly="isPrint || readonly"/>
          </td>
          <td :title="row.만료일">
            <p v-if="isPrint || readonly" class="w-full flex-1">
              {{ row.만료일 }}
            </p>
            <date-selector v-else v-model="row.만료일" :readonly="isPrint || readonly"/>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import DisasterClassSelector from '@/components/selector/DisasterClassSelector'
import CheckTypeASelector from '@/components/selector/CheckTypeASelector'
import FileUploaderTransparent from "@/components/FileUploaderTransparent2.vue";
import SimpleSpinner from "@/components/spinner/SimpleSpinner.vue";
import DateSelector from "@/components/selector/DateSelector.vue";

export default {
  name: 'TableRiskAppraisal688',
  components: {
    DateSelector,
    SimpleSpinner,
    FileUploaderTransparent,
    CheckTypeASelector,
    DisasterClassSelector,

  },
  props: {
    title: {
      type: String,
      default: () => '4M 위험성 평가표'
    },
    isPrint: Boolean,
    readonly: Boolean,
    hideCodeNumber: Boolean,
    value: Array,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        this.list = value

        if (this.list.length === 0) {
          this.handleAddRow()
        }
      }
    },
    list: {
      immediate: false,
      deep: true,
      handler(value) {
        this.$emit("input", value)
      }
    }
  },
  computed: {
    allChecked () {
      let allCheck = true;
      for (const item of this.list) {
        if (!item.input_check) {
          allCheck = false
          break;
        }
      }
      return allCheck;
    },

  },
  data () {
    return {
      loadingSpinners: [],
      optionsNumber1: [
        {value: 1, label: '1'},
        {value: 2, label: '2'},
        {value: 3, label: '3'},
        {value: 4, label: '4'},
        {value: 5, label: '5'}
      ],
      optionsNumber2: [
        {value: 1, label: '1'},
        {value: 2, label: '2'},
        {value: 3, label: '3'},
        {value: 4, label: '4'}
      ],
      showInfoPopup1: false,
      showInfoPopup2: false,
      showInfoPopup3: false,
      list: []
    }
  },
  methods: {
    setFile(index, file) {
      this.list[index].id = file ? file.id : null;
      this.list[index].path = file ? file.path : null;
      this.list[index].fileName = file ? file.fileName : null;
    },
    fileProgress (index, state) {
      if (state === 'start') {
        this.loadingSpinners[index] = true;
      } else if (state === 'success') {
        this.loadingSpinners[index] = false;
        this.$toast.open({type: 'default', message: '이미지 업로드가 완료되었습니다.', position: 'bottom', duration: 2000});
      } else if (state === 'fail') {
        this.loadingSpinners[index] = false;
        this.$toast.open({type: 'error', message: '이미지 업로드가 완료되었습니다.', position: 'bottom', duration: 2000});
      }
    },

    handleCheckAll (e) {
      const checked = e.target.checked
      this.list.forEach(e => {
        e.input_check = checked
      })
    },

    handleAddRow () {
      this.list.push({
        id: this.list.length,
        input_check: false,
        input_2: '',
        input_3: '',
        input_4: '',
        input_5: '',
        input_5_0: '',
        사진내용: '',
        등록번호: '',
        등록일: '',
        만료일: '',
      })
    },
    handleRemoveRow () {
      this.list = this.list.filter(x => x.input_check === false)
    },
    handleTypeInput(index) {
      const input_2 = this.list[index].input_2
      const options = this.handleAppraisalType(input_2)
      if (input_2 !== '기타' && !options.find(x => x.value === this.list[index].input_4)) {
        this.list[index].input_4 = ''
      }
    },
    handleAppraisalType (type) {
      if (type === '기계(설비)적 요인') {
        return [
          {text: '끼임(감김)', value: '끼임(감김)'},
          {text: '위험한 표면(절단, 베임, 긁힘)', value: '위험한 표면(절단, 베임, 긁힘)'},
          {text: '기계(설비)의 낙하, 비래, 전복, 붕괴, 전도 위험 부분', value: '기계(설비)의 낙하, 비래, 전복, 붕괴, 전도 위험 부분'},
          {text: '충돌위험 부분', value: '충돌위험 부분'},
          {text: '넘어짐(미끄러짐, 걸림, 헛디딤)', value: '넘어짐(미끄러짐, 걸림, 헛디딤)'},
          {text: '추락위험 부분(개구부 등)', value: '추락위험 부분(개구부 등)'},
        ]
      } else if (type === '전기적 요인') {
        return [
          {text: '감전(안전전압초과)', value: '감전(안전전압초과)'},
          {text: '아크', value: '아크'},
          {text: '정전기', value: '정전기'},
          {text: '화재 / 폭발 위험', value: '화재 / 폭발 위험'},
        ]
      } else if (type === '화학(물질)적 요인') {
        return [
          {text: '가스', value: '가스'},
          {text: '증기', value: '증기'},
          {text: '에어로졸·흄', value: '에어로졸·흄'},
          {text: '액체·미스트', value: '액체·미스트'},
          {text: '고체(분진)', value: '고체(분진)'},
          {text: '반응성 물질', value: '반응성 물질'},
          {text: '방사선', value: '방사선'},
          {text: '화재 / 폭발 위험', value: '화재 / 폭발 위험'},
          {text: '복사열 / 폭발과압', value: '복사열 / 폭발과압'},
        ]
      } else if (type === '생물학적 요인') {
        return [
          {text: '병원성 미생물, 바이러스에 의한 감염', value: '병원성 미생물, 바이러스에 의한 감염'},
          {text: '유전자 변형물질(GMO)', value: '유전자 변형물질(GMO)'},
          {text: '알러지 및 미생물', value: '알러지 및 미생물'},
          {text: '동물', value: '동물'},
          {text: '식물', value: '식물'},
        ]
      } else if (type === '작업특성 요인') {
        return [
          {text: '소음', value: '소음'},
          {text: '초음파·초저주파음', value: '초음파·초저주파음'},
          {text: '진동', value: '진동'},
          {text: '근로자 실수(휴먼에러)', value: '근로자 실수(휴먼에러)'},
          {text: '저압 또는 고압상태', value: '저압 또는 고압상태'},
          {text: '질식위험·산소결핍', value: '질식위험·산소결핍'},
          {text: '중량물 취급작업', value: '중량물 취급작업'},
          {text: '반복작업', value: '반복작업'},
          {text: '불안정한 작업자세', value: '불안정한 작업자세'},
          {text: '작업(조작)도구', value: '작업(조작)도구'},
          {text: '기후 / 고온 / 한랭', value: '기후 / 고온 / 한랭'},
        ]
      } else if (type === '작업환경 요인') {
        return [
          {text: '기후 / 고온 / 한랭', value: '기후 / 고온 / 한랭'},
          {text: '조명', value: '조명'},
          {text: '공간 및 이동통로', value: '공간 및 이동통로'},
          {text: '주변 근로자', value: '주변 근로자'},
          {text: '작업시간', value: '작업시간'},
          {text: '조직 안전문화', value: '조직 안전문화'},
          {text: '화상', value: '화상'},
          {text: '작업(조작) 도구', value: '작업(조작) 도구'},
        ]
      } else if (type === '기타') {
        return [{text: '기타', value: '기타'}]
      }
    },
    위험기계기구설비옵션() {
      return [
        {text: '고소작업대(「자동차관리법」 제3조제3호 또는 제4호에 따른 화물자동차 또는 특수자동차에 탑재한 고소작업대로 한정한다)', value: '고소작업대(「자동차관리법」 제3조제3호 또는 제4호에 따른 화물자동차 또는 특수자동차에 탑재한 고소작업대로 한정한다)'},
        {text: '곤돌라', value: '곤돌라'},
        {text: '국소 배기장치(이동식은 제외한다)', value: '국소 배기장치(이동식은 제외한다)'},
        {text: '롤러기(밀폐형 구조는 제외한다)', value: '롤러기(밀폐형 구조는 제외한다)'},
        {text: '리프트', value: '리프트'},
        {text: '사출성형기[형 체결력(型 締結力) 294킬로뉴턴(KN) 미만은 제외한다]', value: '사출성형기[형 체결력(型 締結力) 294킬로뉴턴(KN) 미만은 제외한다]'},
        {text: '산업용 로봇', value: '산업용 로봇'},
        {text: '압력용기', value: '압력용기'},
        {text: '원심기(산업용만 해당한다)', value: '원심기(산업용만 해당한다)'},
        {text: '전단기', value: '전단기'},
        {text: '컨베이어', value: '컨베이어'},
        {text: '크레인(정격 하중이 2톤 미만인 것은 제외한다)', value: '크레인(정격 하중이 2톤 미만인 것은 제외한다)'},
        {text: '프레스', value: '프레스'},
        {text: '직접입력', value: '직접입력'},
        {text: '해당없음', value: '해당없음'},
      ];
    }
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;

.form-table {
  border-collapse: collapse;
}
.form-table th, .form-table td {
  border: $border;
  padding: 10px;
  text-align: center;
}
/* .form-table tr 3번째부터 10번째 td까지 */
.form-table tr th:nth-child(n+3) {
  width: calc((100% - 264px) / 7);
}

.form-header-row th {
  height: 50px;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  min-width: 140px;
}

/* 평가표 헤더 설정 */
.form-group__header {
  height: 50px !important;
}

.upload-content__file {
  width: 100%;
  padding-top: 72.25%;
  position: relative;
  border-radius: 6px;
}
.upload-content__content {
  position: absolute;
  top: 2px;
  left: 2px;
  right: 2px;
  bottom: 2px;
  background-position: center center;
  background-size: cover;

  .printImg {
    background-color: white;
    border-radius: 6px;
  }
}

.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bl {
  border-left: $border;
}

.bb {
  border-bottom: $border;
}
</style>

